import React, { useState, useEffect, useRef } from "react";

import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";
import moment from "moment";

import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Tooltip,
  Modal,
  notification,
  Tabs,
  Select,
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SendOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { odata } from "../Filters/Helper";

const DbsInvoiceErpNotAddedSummary = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    activeTab: "0",
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [sendInvoiceLoading, setSendInvoiceLoading] = useState(false);
  const [order, setOrder] = useState("");

  useEffect(() => {
    if (props.data) {
      setTableData({
        data: props.data,
        total: props.data.length,
        loading: false,
      });
    }
  }, []);

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const onConfirmDeleteErpDbsInvoices = () => {
    setSendInvoiceLoading(true);
    RequestHandler.delete("/ErpDbsInvoice", {
      ErpDbsInvoiceIds: selectedRowKeys,
    }).then((response) => {
      setSendInvoiceLoading(false);
      var remainingData = tableData.data.filter(
        (x) => !selectedRowKeys.includes(x.id)
      );
      if (remainingData?.length === 0) {
        setTimeout(function () {
          window.location.reload();
        }, 2000);
      } else {
        setTableData({
          data: remainingData,
          total: remainingData.length,
          loading: false,
        });
      }
    });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onTableSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.isSending, // isSending true ise seçimi devre dışı bırak
    }),
  };

  const erpDbsInvoiceColumns = [
    {
      title: "Bayi Adı",
      dataIndex: "dbsDealerName",
    },
    {
      title: "Bayi Kodu",
      dataIndex: "dealerCode",
    },
    {
      title: "Fatura Tarihi",
      dataIndex: "invoiceDate",
      sorter: true,
      key: "invoiceDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Vade Tarihi",
      dataIndex: "dueDate",
      sorter: true,
      key: "dueDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Fatura Numarası",
      dataIndex: "invoiceNumber",
    },
    {
      title: "Fatura Tutarı",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Şube Kodu",
      dataIndex: "branchCode",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
  ];

  const onConfirmErpDbsInvoice = () => {
    RequestHandler.post(
      "/ErpDbsInvoice",
      {
        bankId: props.bankId,
        ErpDbsInvoiceIds: selectedRowKeys,
        ignoreDealerLimit: true,
      },
      false
    ).then((response) => {
      if (response.value && response.value.length > 0) {
        setTableData({
          data: response.value,
          total: response.value.length,
          loading: false,
        });
        setSendInvoiceLoading(false);
      } else {
        notification.success({
          message: `${selectedRowKeys.length} adet fatura eklendi.`,
          duration: 5,
        });

        var remainingData = tableData.data.filter(
          (x) => !selectedRowKeys.includes(x.id)
        );

        if (remainingData?.length === 0) {
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        }
        setTableData({
          data: remainingData,
          total: remainingData.length,
          loading: false,
        });
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> EKLENEMEYEN FATURA LİSTESİ
          </p>
        </Col>
        <Col xs={24} md={8} lg={6} style={{ textAlign: "right" }}>
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmDeleteErpDbsInvoices}
          >
            <Button
              disabled={selectedRowKeys.length < 1}
              loading={sendInvoiceLoading}
              style={{ marginBottom: 0, marginRight: 15 }}
            >
              <SendOutlined /> Faturaları Sil
            </Button>
          </Popconfirm>
        </Col>
        <Col xs={24} md={4} lg={2} style={{ textAlign: "right" }}>
          <Popconfirm
            title="Göndermek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmErpDbsInvoice}
          >
            <Button
              disabled={selectedRowKeys.length < 1}
              loading={sendInvoiceLoading}
              style={{ marginBottom: 0, marginRight: 15 }}
            >
              <SendOutlined /> Yine de Yükle
            </Button>
          </Popconfirm>
        </Col>
      </Row>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={rowSelection}
            columns={erpDbsInvoiceColumns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
              showSizeChanger: true,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default DbsInvoiceErpNotAddedSummary;
